import React from 'react';
import AboutImage from '../assets/images/about.png';

function About() {
    return (
        <section className="about" id="about">
            <div className="about-img">
                <img src={AboutImage} alt="Rastra D. Karki" />
            </div>
            <div className="about-content">
                <h2 className="heading">About <span>Me</span></h2>
                <h3>MSc in Artificial Intelligence | Full Stack Developer | 5+ Years Experience</h3>
                <p>
                    I am a passionate <strong>Software Engineer and AI Specialist</strong> with over <strong>5+ years of professional experience</strong> designing and deploying AI recommendation systems, full stack web applications, and scalable backend solutions.
                </p>
                <p>
                    I hold an <strong>MSc in Artificial Intelligence (Distinction)</strong> from <strong>Queen Mary University of London</strong>, where my research focused on <strong>AI-based oral health assessment</strong>, applying computer vision and machine learning techniques to real-world healthcare challenges.
                </p>
                <p>
                    I also completed my <strong>BSc (Hons) in Computing</strong> from <strong>Coventry University</strong>, with a final-year project that delivered a <strong>machine learning–based job recommendation system</strong>, improving candidate-to-role matching accuracy.
                </p>
                <p>
                    My strength lies in combining <strong>strong software engineering fundamentals</strong>, <strong>advanced AI research</strong>, and a <strong>problem-solving mindset</strong> to create intelligent solutions with measurable impact.
                </p>
                <div className="about-links" style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
                    <a href="#contact" className="btn">Let's Connect</a>
                    <a 
                        href="https://www.linkedin.com/in/rastrakarki/" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="btn btn-outline"
                    >
                        View LinkedIn
                    </a>
                </div>
            </div>
        </section>
    );
}

export default About;